import PolicyLayout from './PolicyLayout';
import { POLICY_UPDATED, SITE_DOMAIN, SUPPORT_EMAIL } from '../constants/site';

export default function PrivacyPolicy() {
  return (
    <PolicyLayout
      title="Privacy Policy"
      updated={POLICY_UPDATED}
      intro={`This policy explains what we collect when you use ${SITE_DOMAIN}, why we collect it and how long we keep it.`}
    >
      <h2>What we collect</h2>
      <p>
        When you submit a form we collect your name, email address, the accounting software
        version you selected and whatever you type into the message field. A phone number is
        optional and only used if you ask us to call. Our servers also record standard request
        data such as IP address, browser type and the page you arrived from.
      </p>

      <h2>Why we collect it</h2>
      <p>
        We use your details to answer your request, diagnose the issue you described and
        provide a quote. We do not sell your data, and we do not add you to marketing lists
        without your consent.
      </p>

      <h2>Data file access</h2>
      <p>
        If a diagnosis requires access to your accounting data file, we work on an encrypted
        copy. That copy is stored only for the duration of the engagement and is deleted once
        you confirm the work is complete.
      </p>

      <h2>Retention</h2>
      <p>
        Enquiry records are kept for up to 24 months so we can reference prior work on your
        file. You can ask us to delete them sooner at any time.
      </p>

      <h2>Cookies</h2>
      <p>
        We use a small number of cookies to keep the site working and to understand which
        pages people find useful. You can block them in your browser without losing access to
        any part of the site.
      </p>

      <h2>Your rights</h2>
      <p>
        You can request a copy of the data we hold about you, ask for corrections or ask us to
        erase it. Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> and we will
        respond within 30 days.
      </p>
    </PolicyLayout>
  );
}
